import { render } from "./KnowledgeAssistantPage.vue?vue&type=template&id=0d524ef5&scoped=true"
import script from "./KnowledgeAssistantPage.vue?vue&type=script&lang=js"
export * from "./KnowledgeAssistantPage.vue?vue&type=script&lang=js"

import "./KnowledgeAssistantPage.vue?vue&type=style&index=0&id=0d524ef5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d524ef5"]])

export default __exports__